import {
  Navigation,
  RequiredDashboardData,
} from "@nju/feature-portal-dashboard";
import { Footer } from "@nju/feature-portal-footer";
import { Header } from "@nju/feature-portal-header";
import { DashboardHelpPage } from "@nju/feature-portal-help";
import { BlockContent, LayoutWrapper } from "@nju/ui";

export default function Help() {
  return (
    <LayoutWrapper>
      <Header />
      <BlockContent grid="narrow" spacing="xl" tone="gray">
        <RequiredDashboardData extendedMode="base">
          <Navigation title="pomoc" />
          <DashboardHelpPage />
        </RequiredDashboardData>
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
